// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kwdG","fullView":"styles_fullView__1cOJQ"};